<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">{{ info?.tell_us_more }}</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <div class="d-flex justify-content-center mt-2">
    <div class="mr-2 line-height-30">
      <img loading="lazy" data-src="/assets/images/medical-plus.png" alt="cause-icon">
    </div>
    <div class="d-flex flex-column align-items-start">
      <div [ngSwitch]="util.storage.get('language')">
        <div *ngSwitchCase="'Hindi'">
          <div class="line-height-30" >
            <b>चिकित्सा उपचार</b> उद्देश्य के लिए धन जुटाना
          </div>
        </div>
        <div *ngSwitchCase="'English'">
          <ng-container [ngTemplateOutlet]="defaultCase"></ng-container>
        </div>
        <div *ngSwitchCase="'Tamil'">
          <ng-container [ngTemplateOutlet]="defaultCase"></ng-container>
        </div>
        <div *ngSwitchCase="'Telugu'">
          <b>వైద్య చికిత్స</b> కోసం డబ్బుల సేకరణ 
        </div>
        <div *ngSwitchDefault>
          <ng-container [ngTemplateOutlet]="defaultCase"></ng-container>
        </div>
      </div>
      <span class="style-as-link" (click)="openChangePurpose()" *ngIf="!draft">{{ info.change_purpose }}?</span>
    </div>
  </div>
  <form class="form-container m-10" [formGroup]="basicForm" (ngSubmit)="basic()" autocomplete="off">
    <app-input class="app-input"
      inputType="number"
      [control]="amount_requested"
      [group]="basicForm"
      [placeHolder]="info.amount.placeholder"
      icon="icon-help"
      [hint]="info.amount.hint"
      [info]="info.amount.popover"
      preIcon="icon-rupee"
      [errorMessage]="info.amount.error" >
    </app-input>
    <mat-form-field class="mt-2">
      <mat-label>{{ info.patientIsMy }}</mat-label>
      <mat-select [formControl]="relation">
        <mat-optgroup *ngFor="let group of relationship" [label]="group.name">
          <mat-option *ngFor="let relation of group.relations" [value]="relation.value">
            {{ relation.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-error *ngIf="relation.hasError('required') && relation.touched">{{info.fieldRequired}}</mat-error>
    </mat-form-field>

    <div *ngIf="basicForm" class="campaigner-details">
      <mat-form-field class="mt-2">
        <mat-label>{{ info?.qualification }}</mat-label>
        <mat-select [formControl]="qualification">
          <mat-option *ngFor="let item of qualificationList" [value]="item.key">
            {{ item.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="qualification.hasError('required') && qualification.touched">{{info?.fieldRequired}}</mat-error>
      </mat-form-field>

      <mat-form-field class="mt-2">
        <mat-label>{{ info?.occupation }}</mat-label>
        <mat-select [formControl]="occupation">
          <mat-option *ngFor="let item of occupationList" [value]="item.key">
            {{ item.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="occupation.hasError('required') && occupation.touched">{{info?.fieldRequired}}</mat-error>
      </mat-form-field>
    </div>

    <app-intl-input
      *ngIf="askCampaignerPhone"
      class="intl-input-container"
      [group]="basicForm"
      [control]="campaignerPhone"
      [hideSuffixIcon]="false">
    </app-intl-input>

    <app-select *ngIf="brandSurveyData" [placeHolder]="info.survey.placeholder"
      [group]="basicForm"
      [control]="survey"
      [config]="surveyDataConfig"
      [data]="brandSurveyData"
      (onChange)="onSurveySelect($event)"
      [errorMessage]="info.survey.error"
      >
    </app-select>
    <app-image-upload [info]="info"></app-image-upload>
    <button id="submitBtn1" style="display: none" ></button>
    <span class="bottom-text">{{ info.change_easily}}</span>
  </form>
  <div class="no-charges">
    {{ info.ketto_zero_fee }}
  </div>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="   ">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{ info.save_and_continue }}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</mat-card-footer>
<ng-template #defaultCase>
  <div class="line-height-30">
    {{ info.raising_funds_for }} <b>{{ info.medicalTreatment }} </b> {{ info.purposeText }}
  </div>
</ng-template>
